import { useListProperties, useListUnits } from '@myrentalmate/api-client';
import { useMemo } from 'react';

import { okItems } from '../../lib/apiData';

/** "Oak Apartments · 101" for every unit, for pickers and lists. */
export function useUnitLabels(): Map<number, string> {
  const properties = useListProperties({ page_size: 200 });
  const units = useListUnits({ page_size: 200 });
  return useMemo(() => {
    const names = new Map(okItems(properties.data).map((p) => [p.id, p.name]));
    return new Map(
      okItems(units.data).map((u) => [
        u.id,
        `${names.get(u.property_id) ?? ''} · ${u.unit_number}`,
      ]),
    );
  }, [properties.data, units.data]);
}
